import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import card_services from "services/card_services";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";

export function useCardBalances(targets: string[]) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  return useQuery({
    // The card LIST is token-independent; a card's BALANCE is not. Token in the key is what makes
    // the grid refetch on a token toggle instead of showing the previous token's figures.
    queryKey: ["balances", "cards", targets, token],
    queryFn: () =>
      card_services.fetchBalancesByAddresses(targets, networkType, token),
    enabled: !!user && targets.length > 0,
  });
}
